import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import { closeConfirmDialog } from 'actions/confirm-dialog'
import { Button } from '@material-ui/core'
import useStyles from './styles'

const ConfirmDialog = props => {
  const classes = useStyles()

  const open = useSelector(state => state.confirmDialog.open)
  const data = useSelector(state => state.confirmDialog.data)

  const dispatch = useDispatch()

  const handleClose = confirm => {
    dispatch(closeConfirmDialog(confirm))
  }

  const markup = useMemo(() => {
    if (data.text) {
      return { __html: data.text }
    } else {
      return { __html: 'Are you sure?' }
    }
  }, [data.text])

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      aria-labelledby="responsive-dialog-title"
    >
      <DialogContent>
        <Typography
          style={{ fontSize: 18, textAlign: 'center' }}
          dangerouslySetInnerHTML={markup}
        />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          style={{ marginRight: 8 }}
          size="small"
          variant="contained"
          onClick={() => handleClose(false)}
        >
          No
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => handleClose(true)}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/dialogs/Confirm/index.jsx